import { Widget, WidgetProps } from "@rjsf/core";

import { FormMessage, Input } from "@xometry/xometry_loft";
import { FormContext } from "../types";

import { LabelWithOptionalFlag } from "./LabelWithOptionalFlag";
import { Section, ShortText } from "./Shared.style";

export const LoftStringField: Widget = ({
  disabled,
  formContext,
  onBlur,
  onChange,
  options,
  rawErrors,
  required,
  schema,
  uiSchema,
  value,
}: WidgetProps) => {
  const isInvalid = !!(rawErrors?.length > 0 && options?.touched);
  const { scale } = formContext as FormContext;
  return (
    <div css={[Section, options?.short && ShortText]}>
      {schema.title !== undefined && (
        <LabelWithOptionalFlag
          required={required}
          tooltip={(options?.tooltip || "") as string}
        >
          {schema.title}
        </LabelWithOptionalFlag>
      )}
      <Input
        name={options?.name as string}
        disabled={disabled}
        invalid={isInvalid}
        defaultValue={value}
        onChange={e => {
          onChange(e.currentTarget.value || undefined);
        }}
        onBlur={e => {
          onBlur(e.currentTarget.name, e.currentTarget.value || null);
        }}
        scale={scale}
      />
      {uiSchema?.description && (
        <FormMessage>{uiSchema.description}</FormMessage>
      )}
      {isInvalid && (
        <FormMessage invalid>{rawErrors ? rawErrors[0] : ""}</FormMessage>
      )}
    </div>
  );
};
